<template>
  <div>
    <h4><translate>Answer choices:</translate></h4>

    <tabs :value="activeEditor" @activate-tab-key="(e) => (activeEditor = e)">
      <tab-pane :title="'Table' | translate" key="table">
        <el-table :data="value">
          <el-table-column :label="'Value' | translate" width="180">
            <template slot-scope="choice">
              <fg-input required :placeholder="'Value' | translate" v-model="choice.row.value"></fg-input>
            </template>
          </el-table-column>
          <el-table-column :label="'Label' | translate">
            <template slot-scope="choice">
              <fg-input required :placeholder="'Label' | translate" v-model="choice.row.label"></fg-input>
            </template>
          </el-table-column>
          <el-table-column
            :label="'Clarify' | translate"
            width="180">
            <template slot-scope="props">
              <p-switch v-model="props.row.clarify" color="black"></p-switch>
            </template>
          </el-table-column>
          <el-table-column width="60">
            <template slot-scope="choice">
              <el-tooltip :content="'Delete' | translate" placement="top">
                <p-button type="danger" size="sm" icon @click="(e) => removeChoice(e, choice.$index)">
                  <i class="fa fa-times"></i>
                </p-button>
              </el-tooltip>
            </template>
          </el-table-column>

        </el-table>
        <el-tooltip :content="'Add choice' | translate" placement="top">
          <p-button type="success" size="sm" icon @click="addChoice">
            <i class="fa fa-plus"></i>
          </p-button>
        </el-tooltip>
      </tab-pane>
      <tab-pane :title="'List' | translate" key="list">
        <ExtendedMonacoEditor
          @onDidBlurEditorWidget="fromMonaco"
                      ref="valuesEditor"
                      v-model="valuesList"
                      theme="vs-dark"
                      language="plaintext"
                      height="150"
        ></ExtendedMonacoEditor>
      </tab-pane>
    </tabs>
  </div>
</template>

<script>
  import {Table, TableColumn, Select, Option, Tooltip} from 'element-ui'
  import { Tabs, TabPane, Switch, Card, Button} from 'src/components/UIComponents'
  import MonacoEditor from 'monaco-editor-vue';
  import Vue from 'vue'

  const ExtendedMonacoEditor = {
    extends: MonacoEditor,
    mounted () {
      // Пробрасываем события из Monaco в Vue
      Object.keys(this.editor).filter(e => e.startsWith('on')).map(f => {
        this.editor[f](e => {this.$emit(f, e)})
      })
    }
  }

  export default {
    components: {
      Button,
      Card,
      Tabs,
      TabPane,
      MonacoEditor,
      ExtendedMonacoEditor,
      [Tooltip.name]: Tooltip,
      [Switch.name]: Switch,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      value: Array
    },
    data () {
      return {
        valuesList: null,
        activeEditor: 'list',
        expandedRows: []
      }
    },
    name: 'AnswerChoices',
    methods: {
      addChoice (e) {
        // FIXME: Костыль, чтобы не схлопывалась таблица
        this.$parent.$parent.$parent.expandedRows = this.$parent.store.states.expandRows.map(r => r.key)
        this.value.push({
          value: null,
          label: null,
          clarify: null,
        })
      },
      removeChoice (e, index) {
        // FIXME: Костыль, чтобы не схлопывалась таблица
        this.$parent.$parent.$parent.expandedRows = this.$parent.store.states.expandRows.map(r => r.key)
        this.value.splice(index, 1)
      },
      toMonaco() {
        this.valuesList = this.value.map(e => e.clarify ? `${e.label}*` : e.label).join('\n')
      },
      fromMonaco() {
        this.value.length = 0
        this.valuesList.split('\n').filter(e => e.trim().length > 0).map((e, i) => {
          e = e.trim()
          let clarify = false
          if (e.endsWith('*')) {
            clarify = true
            e = e.replace(/\*+$/, '')
          }
          e = e.trim()
          return {label: e, value: i, clarify}
        }).map(e => this.value.push(e))
      }
    },
    mounted () {
      this.toMonaco()
    },
    watch: {
      activeEditor (newValue, oldValue) {
        switch (oldValue) {
          case 'list':
            this.fromMonaco()
            break
          case 'table':
            this.toMonaco()
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>
